import gql from 'graphql-tag';

export const PromoCodeDetails = gql`
  fragment PromoCodeDetails on PromoCode {
    id
    type
    code
    discount {
      mode
      value
      duration {
        mode
      }
    }
    expires_at
  }
`;

export const AccountPromoCodeDetails = gql`
  fragment AccountPromoCodeDetails on AccountPromoCode {
    id
    type
    code
    is_active
    is_expired
    discount {
      mode
      value
      duration {
        mode
      }
    }
    account_referrals_count
    usage_limit {
      mode
      value
    }
    expires_at
  }
`;
